import { formatCLP } from "../../../../helpers/functions";

const ProductCard = ({ plan }) => {
  const validityLabel =
    plan.validityUnit === "MONTH"
      ? `${plan.validityAmount} ${plan.validityAmount === 1 ? "mes" : "meses"}`
      : `${plan.validityAmount} ${plan.validityAmount === 1 ? "año" : "años"}`;

  return (
    <div className="gm-checkout-product-card">
      <div className="gm-plan-card gm-plan-card--recommended">
        <div className="gm-plan-name">{plan.name}</div>
        <div className="gm-plan-tests-label">
          {plan.testsQuantity} {plan.testsQuantity === 1 ? "test" : "tests"}/año
        </div>
        <div className="gm-plan-price">{formatCLP(plan.totalPrice)}</div>
        <div className="gm-plan-price-period">al año</div>
        <div className="gm-plan-unit-price">{formatCLP(plan.unitPrice)} por test</div>
        {plan.discountPercentage > 0 && (
          <div className="gm-plan-discount">{plan.discountPercentage}% ahorro</div>
        )}
        <div className="gm-checkout-product-validity">Vigencia: {validityLabel}</div>
      </div>
    </div>
  );
};

export default ProductCard;
